module.exports = __webpack_public_path__ + "img/2.7_Russian_road_sign.a087060d.svg";